export default __webpack_public_path__ + "static/media/KK_R_Right_Bottom_aCrop.4490ce7e.svg";